/**
 * Shell section-tab first paint on KEEP doors.
 * Folded children stay at URL. Roster five-destination strip is the one-door
 * interior (KEEP). Home-care hub strips are folded
 * unless ?more=1.
 */

export function sectionTabsMoreRequested(raw?: string | null): boolean {
  const value = String(raw ?? '')
    .trim()
    .toLowerCase();
  return value === '1' || value === 'true';
}

function pathnameWithoutQuery(pathname: string | null | undefined): string {
  return String(pathname ?? '').split('?')[0] ?? '';
}

export function isPeopleHubPath(pathname: string | null | undefined): boolean {
  const path = pathnameWithoutQuery(pathname);
  return path === '/people' || path === '/people/';
}

export function isServiceDeliveryKeepPath(pathname: string | null | undefined): boolean {
  const path = pathnameWithoutQuery(pathname);
  return path === '/home-care/service-delivery' || path.startsWith('/home-care/service-delivery/');
}

export function shouldPaintSectionTabFirstPaint(input: {
  parentHref: string;
  tabHref: string;
  pathname: string;
  more?: boolean;
}): boolean {
  if (input.more) return true;
  if (input.parentHref === '/roster') return true;
  if (input.parentHref === '/home-care' && isServiceDeliveryKeepPath(input.pathname)) {
    return input.tabHref === '/home-care/service-delivery';
  }
  return true;
}
